"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'noop',
    synopsis: 'noop',
    description: 'No operation',
    execute: function execute() {}
  };
};

exports.default = _default;